import styled from 'styled-components'

export const Container = styled.span`
  color: var(--sl-fg-base);
  display: inline-flex;

  flex-direction: row-reverse;

  border: 0.125rem solid var(--sl-color-gray-0);
  background-color: var(--sl-bg-base-strong);
  border-radius: 2rem;

  .label {
    padding: 0.25rem 0.5rem;
    background-color: color-mix(in srgb, var(--primary) 30%, transparent);
    border-top-right-radius: 2rem;
    border-bottom-right-radius: 2rem;
  }

  .text {
    padding: 0.25rem 0.5rem;
  }
`
